
import { TypeFiltre } from '@estel-numerique/galaclick-core';
import { AgendaEtapesEnum } from '../enum/agendaEtapesEnum';
import { TranslateService } from '@ngx-translate/core';


export class AgendaWebHelper {

    public static getFiltreEvenementSuiviActivites(translate: TranslateService): TypeFiltre<AgendaEtapesEnum>[] {
        return [
            new TypeFiltre(AgendaEtapesEnum.REALISE, translate.instant("STATUTAGENDA.REALISE"), false),
            new TypeFiltre(AgendaEtapesEnum.PLANIFIE, translate.instant("STATUTCPERF.PLA"), false),
        ];

    }


}
